<!--
 * @Author: hfxie
 * @Date: 2022-05-07 16:39:34
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 11:18:47
 * @Description: 虚拟列表
-->

<template>
  <div
    ref="list"
    class="scroll-list-container infinite-list-container"
    @scroll.passive="scrollEvent($event)"
  >
    <div
      ref="phantom"
      class="infinite-list-phantom"
      :style="getHeight"
    ></div>
    <div
      class="infinite-list"
      :class="{
        'gantt-outbox-border': (!$store.state.viewSchem.noGanttOutBoxBorder),
      }"
      ref="content"
    >
      <div
        class="infinite-list-item"
        :class="{
          'list-item-border-bottom': item.borderBottom == true,
        }"
        ref="items"
        :data-name="item.name"
        :data-id="item.id"
        v-for="item in visibleData"
        :key="item.id"
        :style="{
          'height': ((item.rowCount?item.rowCount:1) * estimatedItemSize  + 'px'),
          'color': item.color,
        }"
      >
        <slot ref="slot" :item="item"></slot>
      </div>
    </div>
  </div>
</template>


<script>
/*
  常规需要自己动态计算position
  ( 打开created的注释调用initPositions(),updated的updateItemsSize(),watch里的initPositions()以及注释掉传入的props里的position )
  由于该虚拟嵌套过多上层能直接计算就直接上升到父级计算完通过prop传入进来 该页面直接取用
*/
export default {
  name: "VirtualList",
  data() {
    return {
      // 可视区域高度
      screenHeight: 0,
      // 起始索引
      start: 0,
      // 结束索引
      end: undefined,
    };
  },
  props: {
    // 所有列表数据
    listData: {
      type: Array,
      default: () => [],
    },
    positions: {
      type: Array,
      default: () => [],
    },
    // 单行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
    // 缓冲区比例
    bufferScale: {
      type: Number,
      default: 1,
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
    scrollTop: {
      type: Number,
      default: () => { return 0; },
    },
  },
  computed: {
    visibleCount() {
      let activeNum = Math.ceil(this.screenHeight / this.estimatedItemSize);
      activeNum = activeNum < this.$store.state.minRowsNum ? this.$store.state.minRowsNum : activeNum;
      return activeNum;
    },
    aboveCount() {
      return Math.min(this.start, this.bufferScale * this.visibleCount);
    },
    belowCount() {
      return Math.min(
        this.listData.length - this.end,
        this.bufferScale * this.visibleCount,
      );
    },
    visibleData() {
      const start = this.start - this.aboveCount < 0 ? 0 : this.start - this.aboveCount;
      const end = this.end + this.belowCount < 0 ? this.$store.state.minRowsNum : this.end + this.belowCount;
      const visibleArr = this.listData.slice(start, end);
      return visibleArr;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  inject: ["CONSTNAME"],
  /* mounted() {
    this.screenHeight = this.$el.clientHeight;
    this.start = 0;
    this.end = this.start + this.visibleCount;
  }, */
  beforeUpdate() {
    this.$nextTick(function() {
      if (!this.$refs.items || !this.$refs.items.length) {
        return;
      }
      // 更新真实偏移量
      this.setStartOffset();
    });
  },
  mounted(){
    let scrollTop = this.scrollTop;
    console.log("V渲染, 距顶", scrollTop);
    this.$el.scrollTop = scrollTop;
    /* 同步定位后确定横道范围 */
    this.screenHeight = this.$el.clientHeight; // 该周期必传
    this.start = this.getStartIndex(scrollTop); // 必传
    this.end = this.start + this.visibleCount; // 必传
    this.setStartOffset();
    this.$emit("handleScroll", { scrollTop, start: this.start - this.aboveCount <= 0 ? 0 : this.start - this.aboveCount, end: this.end + this.belowCount });
    scrollTop = null;
  },
  beforeDestroy(){
    if(!this.$store.state.stayInPlace) {
      console.log("V销毁 回顶");
      this.$emit("handleScroll", { scrollTop: 0 });
    }
    console.log("V销毁");
    
  },
  methods: {
    // 获取列表起始索引
    getStartIndex(scrollTop = 0) {
      return this.binarySearch(this.positions, scrollTop);
    },
    binarySearch(list, value) {
      if (list instanceof Array && list.length > 0) {
        let start = 0;
        let end = list.length - 1;
        let tempIndex = null;

        while (start <= end) {
          const midIndex = parseInt((start + end) / 2);
          const midValue = list[midIndex].bottom;
          if (midValue === value) {
            return midIndex + 1;
          } else if (midValue < value) {
            start = midIndex + 1;
          } else if (midValue > value) {
            if (tempIndex === null || tempIndex > midIndex) {
              tempIndex = midIndex;
            }
            end = end - 1;
          }
        }
        return tempIndex;
      } else {
        return -1;
      }
    },
    // 获取当前的偏移量
    setStartOffset() {
      let startOffset;
      if (this.start >= 1) {
        const size =
          this.positions[this.start].top -
          (this.positions[this.start - this.aboveCount]
            ? this.positions[this.start - this.aboveCount].top
            : 0);
        startOffset = this.positions[this.start - 1].bottom - size;
      } else {
        startOffset = 0;
      }
      if(this.$refs.content){
        this.$refs.content.style.transform = `translate3d(0,${startOffset}px,0)`;
        // console.log("修正偏移量");
      }
    },
    // 滚动事件
    scrollEvent() {
      let scrollTop = this.$el.scrollTop;
      if(this.$store.state[this.CONSTNAME.PLANS + "_hasNext"]) {
        let clientHeight = this.$el.clientHeight;
        let scrollHeight = this.$el.scrollHeight;
        let offSetY = 0;
        let isEnd = (scrollTop + clientHeight >= scrollHeight - 1 - offSetY) && (scrollTop + clientHeight <= scrollHeight + 1);
        if(
          (scrollTop > 0 && scrollHeight > 0)  &&
          isEnd && 
          !this.$store.state.dataLoadingStatus
        ) {
          this.$store.commit("set_dataLoadingStatus", true);
          console.log("V·加载更多");
          this.$store.dispatch("_loadContent", "V·加载更多"); 
        }
      }
      
      // 起止索引
      this.start = this.getStartIndex(scrollTop);
      this.end = this.start + this.visibleCount;
      this.setStartOffset();
      this.$emit("handleScroll", { scrollTop, start: this.start - this.aboveCount <= 0 ? 0 : this.start - this.aboveCount, end: this.end + this.belowCount });
      scrollTop = null;

    },
  },
};
</script>


<style scoped lang='less'>
.infinite-list-container {
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}

.infinite-list-phantom {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
}

.infinite-list {
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
}

.infinite-list-item {
  box-sizing: border-box;
  // border-color: red;
  &.list-item-border-bottom{
    border-bottom: 1px solid @cBorderX;
    border-bottom: 1px solid var(--borderX-color, #666666);
  }
  &:last-of-type {
    border-bottom: none;
  }
}
.infinite-list{
  &.gantt-outbox-border{
    .infinite-list-item{
      .task-info-row{
        border-left: 1px solid @cBorder;
        border-left: 1px solid var(--border-color, @cBorder);
      }
    }
  }
}
</style>
